import { createContext, useContext, useEffect, useRef, useState } from "react";

const SectionContext = createContext();

/*
[
{
id: "sectionId"
name: "sectionName"
containers: [
 containerObj1, containerObj2, ...
]}
]
*/

/*
[containerObj]: {
    id: ""
}
*/


export function SectionProvider({ children }) {
    const [sections, setSections] = useState([]);
    const [containers, setContainers] = useState({});
    const [removedSections, setRemovedSections] = useState([]);
    // History hidden sections
    const [hiddenHistory, setHiddenHistory] = useState([]);
    //#region Sections bar highlight
    const [currentSection, setCurrentSection] = useState("header");

    const areSectionsAdjanced = (sec1, sec2) => {
        let foundI = false;
        for (let i = 0; i < sections.length; i++) {
            const secId = sections[i]?.id || null;
            const sectionHit = sec1 === secId || sec2 === secId;
            if (foundI && sectionHit) {
                return true;
            }
            if (sectionHit) {
                foundI = true;
            } else {
                foundI = false;
            }
        }

        return false;
    }
    //#endregion

    //#region Navigation sectioning
    const addSection = (params = {}) => {
        const { id } = params;
        if (!id) return;

        setSections(prev => {
            const index = prev.findIndex(s => s?.id === id);

            if (index !== -1) {
                const newSections = [...prev]//structuredClone(prev);

                newSections[index] = {
                    ...newSections[index],
                    ...params,
                    // preserve containers if already exist
                    containers: newSections[index].containers || []
                };

                return newSections;
            }

            return [
                ...prev,
                {
                    ...params,
                    containers: params.containers || []
                }
            ];
        });
    };

    const removeSection = (params = {}) => {
        const { id } = params;
        if (!id) return;

        setSections(prev => {
            const index = prev.findIndex(s => s?.id === id);

            if (index === -1) return prev;

            return prev.filter(s => s?.id !== id);
        });

        setRemovedSections(prev => {
            const index = prev.findIndex(s => s?.id === id);

            if (index === -1) {
                return [...prev, params]
            } else {
                return prev;
            }
        })
    };

    const addSectionContainer = (sectionId, params = {}) => {
        if (!sectionId || !params.id) return;
        setSections(prev => {
            const index = prev.findIndex(s => s?.id === sectionId);

            // If section DOES NOT exist → create it safely
            if (index === -1) {
                return [
                    ...prev,
                    {
                        id: sectionId,
                        containers: [params],
                    }
                ];
            }

            // If section exists → update it
            const newSections = [...prev]
            const section = newSections[index];

            const containers = section.containers || [];

            const exists = containers.some(c => c.id === params.id);
            if (exists) return prev;

            section.containers = [...containers, params];

            return newSections;
        });

        removeInvalidContainer(sectionId, params.id);
    };

    const getSection = (sectionId) => {
        return sections.find(s => {
            if (s === undefined) return null;
            return s.id === sectionId;
        }) || [];
    }

    const getSectionContainers = (sectionId) => {
        return sections.find(s => {
            if (s === undefined) return null;
            return s.id === sectionId;
        })?.containers || [];
    }
    //#endregion
    //#region Makes sure section without data wont show
    const addInvalidContainer = (container) => {
        const { sectionId, id: containerId } = container;

        setContainers(prev => {
            const section = prev?.[sectionId];
            const prevArray = section?.invalid || [];

            const already_included = prevArray.find(c => c.id === containerId);
            // prevent duplicates
            if (already_included) return prev;

            return {
                ...prev,
                [sectionId]: {
                    invalid: [...prevArray, container]
                }
            };
        });
    };

    const removeInvalidContainer = (sectionId, containerId) => {
        setContainers(prev => {
            const section = prev?.[sectionId];
            if (!section?.invalid) return prev;

            const newArray = section.invalid.filter(cont => cont?.id !== containerId);

            return {
                ...prev,
                [sectionId]: {
                    invalid: newArray
                }
            };
        });
    };

    //#endregion


    return (
        <SectionContext.Provider value={{
            addSectionContainer, addSection, removeSection, removedSections,
            getSection, getSectionContainers, sections,
            addInvalidContainer, removeInvalidContainer, containers,
            currentSection, setCurrentSection, areSectionsAdjanced,
            // History hidden
            hiddenHistory, setHiddenHistory
        }}>
            {children}
        </SectionContext.Provider>
    );
}

export function useSectionContext() {
    const context = useContext(SectionContext);
    if (!context) {
        throw new Error("useSectionContext must be used within an OpenProvider");
    }
    return context;
}